module.exports = __webpack_public_path__ + "img/competition.1b2b3683.jpg";